export default __webpack_public_path__ + "static/media/clean-room-door.145304da.jpg";